import { render, staticRenderFns } from "./AtomListElementActionsSecondary.vue?vue&type=template&id=06fed38d&"
import script from "./AtomListElementActionsSecondary.vue?vue&type=script&lang=js&"
export * from "./AtomListElementActionsSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports